import axios from 'axios';
import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import Widget from './Widget/Widget';

import { FaAddressBook, FaCalendarDays, FaFileInvoiceDollar, FaPlus, FaTags, FaUserAstronaut } from 'react-icons/fa6';
import { IconWrapper } from '../IconWrapper/IconWrapper';
import styles from './Portal.module.scss';

const Portal = () => {
  const [meetingStats, setMeetingStats] = useState<{ [x: string]: number }>({
    Shortly: 0,
    Total: 0,
  });
  const [expenseStats, setExpenseStats] = useState<{ [x: string]: number }>({
    Active: 0,
    Total: 0,
  });
  const membershipStats: { [x: string]: number } = {
    'Action needed': 0,
    Total: 0,
  };

  const totalTracked = meetingStats.Total + expenseStats.Total;

  useEffect(() => {
    axios.get('/api/meeting/stats').then((response) => {
      if (response.status === 200) {
        setMeetingStats({
          Shortly: response.data.shortly,
          Total: response.data.total,
        });
      }
    });

    axios.get('/api/expense/stats').then((response) => {
      if (response.status === 200) {
        setExpenseStats({
          Active: response.data.active,
          Total: response.data.total,
        });
      }
    });
  }, []);

  return (
    <Container className={styles.Portal}>
      <section className={styles.Hero}>
        <Row className="align-items-center h-100">
          <Col md={8} className={styles.HeroContent}>
            <div className={styles.Eyebrow}>Protec'App · Tableau de bord</div>
            <h1 className={styles.Title}>Pilotez vos activités en un coup d’œil.</h1>
            <p className={styles.Description}>
              Retrouvez vos réunions, notes de frais et suivis d’adhésion depuis un espace unique.
            </p>
          </Col>
          <Col md={4} className="d-flex justify-content-md-end">
            <div className={styles.HeroMetric}>
              <span className={styles.HeroMetricLabel}>Éléments suivis</span>
              <strong className={styles.HeroMetricValue}>{totalTracked}</strong>
            </div>
          </Col>
        </Row>
      </section>

      <div className={styles.SectionHeading}>
        <h2 className={styles.SectionTitle}>Vue d’ensemble</h2>
        <p className={styles.SectionHint}>Sélectionnez un espace pour accéder à ses détails</p>
      </div>
      <Row className="g-4">
        <Col lg={4} md={6}>
          <Widget name="Meetings" subtitle="Préparez vos prochaines réunions" color="green" icon={<IconWrapper icon={FaCalendarDays} />} values={meetingStats} link="/meeting" />
        </Col>
        <Col lg={4} md={6}>
          <Widget name="Expense reports" subtitle="Suivez les frais à traiter" color="violet" icon={<IconWrapper icon={FaFileInvoiceDollar} />} values={expenseStats} link="/expense" />
        </Col>
        <Col lg={4} md={6}>
          <Widget name="Memberships" subtitle="Gardez vos adhésions à jour" color="orange" icon={<IconWrapper icon={FaUserAstronaut} />} values={membershipStats} link="/membership" />
        </Col>
      </Row>

      <div className={styles.SectionHeading}>
        <h2 className={styles.SectionTitle}>Accès rapides</h2>
        <p className={styles.SectionHint}>Les outils utilisés au quotidien</p>
      </div>
      <div className={styles.QuickActions}>
        <Link className={styles.QuickAction} to="/meeting">
          <span className={styles.QuickIcon}><IconWrapper icon={FaPlus} /></span>
          <span><span className={styles.QuickLabel}>Nouvelle réunion</span><span className={styles.QuickDescription}>Créer un rendez-vous</span></span>
        </Link>
        <Link className={styles.QuickAction} to="/addresses">
          <span className={styles.QuickIcon}><IconWrapper icon={FaAddressBook} /></span>
          <span><span className={styles.QuickLabel}>Adresses enregistrées</span><span className={styles.QuickDescription}>Gérer vos destinations</span></span>
        </Link>
        <Link className={styles.QuickAction} to="/activity-types">
          <span className={styles.QuickIcon}><IconWrapper icon={FaTags} /></span>
          <span><span className={styles.QuickLabel}>Types d’activité</span><span className={styles.QuickDescription}>Configurer vos activités</span></span>
        </Link>
      </div>
    </Container>
  );
};

export default Portal;
